export default {
  LandingModule: 'LandingModule',
  CommonModule: 'CommonModule',
  NavigationModule: 'NavigationModule',
  CampaignModule: 'CampaignModule',
  MyDeviceModule: 'MyDeviceModule',
  CompanyProfileModule: 'CompanyProfileModule',
};
